import { observer } from "mobx-react-lite";
import { VirtualizedItemList } from "@/components/item-list";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import { SearchPageNotesListEmpty } from "./search-page-notes-list-empty";

export const SearchPageNotesList = observer(() => {
  const page = useTabPageStore("searchPage");

  if (page.hasNoItems) {
    return (
      <SearchPageNotesListEmpty
        query={page.filters.params.queryString}
        isSuccess={page.isSuccess}
        anyFiltersSelected={page.filters.hasAnyFilters || !page.showDeepSearchResults}
        onRetryClick={page.load}
        onClearFiltersClick={page.filters.clearAllFilters}
      />
    );
  }

  return <VirtualizedItemList rows={page.itemRows} listState={page.listState} />;
});
